import gallery1 from "../../assets/gallery-1.webp";
import gallery2 from "../../assets/gallery-2.webp";
import gallery3 from "../../assets/gallery-3.webp";
import gallery4 from "../../assets/gallery-4.webp";
import gallery5 from "../../assets/gallery-5.webp";
import gallery6 from "../../assets/gallery-6.webp";

const AllGallery = {
  images: [
    {
      img: gallery1,
    },
    {
      img: gallery2,
    },
    {
      img: gallery3,
    },
    {
      img: gallery4,
    },
    {
      img: gallery5,
    },
    {
      img: gallery6,
    },
  ],
};

export default AllGallery;
